import { render } from "./userpayment.vue?vue&type=template&id=3dd3374e&scoped=true"
import script from "./userpayment.vue?vue&type=script&lang=js"
export * from "./userpayment.vue?vue&type=script&lang=js"

import "./userpayment.vue?vue&type=style&index=0&id=3dd3374e&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd3374e"]])

export default __exports__